import axios from 'axios';

const TOPIC = 'erroresDev';
const BASE_URL = 'https://ntfy.sh/';

/**
 * Sends a notification to ntfy.sh
 * @param {string} message - The message to send
 * @param {string} title - Optional title for the notification
 * @param {string} priority - Priority level (1-5, or words like 'min', 'low', 'default', 'high', 'urgent')
 * @param {Array} tags - Optional tags/emojis
 */
export const sendNotification = async (message, title = 'Error en Cotizaciones', priority = 'high', tags = ['warning', 'computer']) => {
    try {
        await axios.post(`${BASE_URL}${TOPIC}`, message, {
            headers: {
                'Title': title,
                'Priority': priority,
                'Tags': tags.join(',')
            }
        });
    } catch (error) {
        console.error('Failed to send ntfy notification:', error);
    }
};

export default {
    sendNotification
};
